import { Component, OnInit, Inject } from '@angular/core';
import { DoctorService } from '../../services/doctor.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-serviceedit',
  templateUrl: './serviceedit.component.html',
  styleUrls: ['./serviceedit.component.css']
})
export class ServiceeditComponent implements OnInit {
  fees: any;
  name: any;
  sid: any;
  temp: any;
  constructor(public DialogRef: MatDialogRef<ServiceeditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private doctorservice: DoctorService) {
      this.sid = data.id;
      this.name = data.name;
      this.temp = data.fees;
      this.fees = data.fees;
    }

  ngOnInit() {
  }
  confirmfees() {
    if (this.fees === this.temp) {
      this.closeDialog(0);
    } else {
      this.doctorservice.editFees(this.sid, this.fees)
      .subscribe(
        (x) => {
          this.closeDialog(1);
        });
    }
  }
  closeDialog(res) {
    this.DialogRef.close(res);
  }

}
